import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import VendorReportsLayer from "../components/VendorReportsLayer";

const VendorReportsPage = () => {
    return (
        <MasterLayout>
            <VendorReportsLayer />
        </MasterLayout>
    );
};

export default VendorReportsPage;
